let overlay;

function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    if (overlay && overlay.parentElement !== image.parentElement) {
      image.parentElement.insertBefore(overlay, image);
    }
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  if (!overlay) return;
  const ratio = image.height / image.width || 1;
  const container = event.currentTarget.getBoundingClientRect
    ? event.currentTarget.getBoundingClientRect()
    : image.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (container.width / 100)}%`;
  const yPercent = `${yPosition / (container.height / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${Math.max(image.naturalWidth, image.width) * zoomRatio}px`;
}

function removeOverlay(image) {
  if (overlay) {
    overlay.remove();
    overlay = null;
  }
  if (image) image.style.opacity = '100%';
}

function magnify(image, zoomRatio) {
  createOverlay(image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => removeOverlay(image);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.zoomBound === 'true') return;
    image.dataset.zoomBound = 'true';

    const media = image.closest('.media') || image.parentElement;

    media.addEventListener('mouseenter', (event) => {
      if (media.querySelector('.image-magnify-full-size')) return;
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    });

    media.addEventListener('mousemove', (event) => {
      if (!overlay) {
        magnify(image, zoomRatio);
      }
      moveWithHover(image, event, zoomRatio);
    });

    media.addEventListener('mouseleave', () => removeOverlay(image));
  });
}

enableZoomOnHover(2);
